import { memo } from 'react';
import { AvatarComponent } from '@/components/ui/avatar/avatar';

interface Props {
  name: string;
  avatar?: string | null;
}

export const WorkflowGroup = memo(({ name, avatar }: Props) => (
  <div
    className="flex flex-none flex-row items-center"
    data-testid="workflow-group"
    data-cy={`workflow-group-${name}`}
  >
    {avatar && (
      <div className="mr-2 shrink-0" data-testid="workflow-group-avatar">
        <AvatarComponent source={avatar} name={name} size={22} />
      </div>
    )}
    {name}
  </div>
));
